module.exports = __webpack_public_path__ + "static/img/govcard_white_05.e3921fd5.svg";